"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "treppo-ligosullo": {
    "a414f671": [{
      "hkey": "d40c1df6",
      "slug": "treppo-ligosullo",
      "name": "Treppo Ligosullo",
      "primary": true,
      "skipSearch": false
    }],
    "gleris": [{
      "hkey": "d40c1df6",
      "slug": "treppo-ligosullo",
      "name": "Treppo Ligosullo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d940a318": [{
      "hkey": "d40c1df6",
      "slug": "treppo-ligosullo",
      "name": "Treppo Ligosullo",
      "primary": true,
      "skipSearch": false
    }],
    "siaio": [{
      "hkey": "d40c1df6",
      "slug": "treppo-ligosullo",
      "name": "Treppo Ligosullo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5835ac43": [{
      "hkey": "d40c1df6",
      "slug": "treppo-ligosullo",
      "name": "Treppo Ligosullo",
      "primary": true,
      "skipSearch": false
    }],
    "zenodis": [{
      "hkey": "d40c1df6",
      "slug": "treppo-ligosullo",
      "name": "Treppo Ligosullo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;